import TableView from "../../views/table";
import { TableButtonsAction, TableButtonsActionType } from "../../views/table/TableToolbar.utils";

export class BackgroundJobTableView extends TableView {
    getToolbarButtons(): TableButtonsActionType[] {
        return [
            TableButtonsAction.CSVExport,
            TableButtonsAction.XLSXExport,
            TableButtonsAction.PdfExport,
            TableButtonsAction.Sorting,
            TableButtonsAction.Settings
        ];
    }
}